import React from 'react';
import slug from 'slug';

import allImages from '../../../assets/img/llc/surgery/procedures';
import specialImages from '../../../assets/img/llc/special';
import './GalleryMenu.scss';

class GalleryMenu extends React.Component {
  constructor() {
    super();

    this.state = {
      active: 1
    }
  }

  hasImages = (surgery, procedure) => {
    const surgerySlag = slug(surgery.name, {lower: true});
    const procedureSlag = slug(procedure.name, {lower: true});
    return (allImages[surgerySlag].full[procedureSlag]);
  };

  renderProcedures = (surgery) => {

    return surgery.procedures.map(proc => {
      if (this.hasImages(surgery, proc) || slug(proc.name, {lower: true}) === "laserove-beleni-zubu")
        return (
          <li
            onClick={this.handleProcedureClick}
            id={proc.id}
            key={proc.id}
            className={parseInt(proc.id) === parseInt(this.props.activeProcedure) ?
              "active" : ""}
          >
            {proc.name}
          </li>
        )
    })
  };

  handleProcedureClick = (e) => {
    this.props.changeContent(this.state.active, e.target.id);
  };

  handleClick = (id) => {
    this.setState({
      active: id
    });

    this.props.surgeryChanged(id);
  };

  renderSurgeries = () => {
    return this.props.langs.surgery.map(sur => {
      if (sur.id === 4) return <span key={sur.id}/>
      const galleryMenuItemClass = "galleryMenu_item " + ((sur.id === this.state.active) ? "active" : "");
      return (
        <div className={galleryMenuItemClass} key={sur.id}>
          <a onClick={this.handleClick.bind(this, sur.id)}
             role="button" className="galleryMenu_item_btn"><i className={`llc-${sur.icon}`}/> {sur.id === 2 ? "Laserová a estetická medicína" : sur.name}</a>
          {this.state.active === sur.id &&
          <ul>
            {this.renderProcedures(sur)}
          </ul>
          }
        </div>
      )
    })
  };

  render() {
    return (
      <section className="galleryMenu">
        <div className="galleryMenu_wrap">
          {this.renderSurgeries()}
        </div>
      </section>
    );
  }
}

export default GalleryMenu;


// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryMenu/GalleryMenu.js